import jinjaToJS from "jinja-to-js";import __$1 from "./cards/promotion_landscape_card";export default function templateModulesFeaturedPromotionsWall(ctx) {
    var __result = "";
    var __tmp;
    var __runtime = jinjaToJS.runtime;
    var __filters = jinjaToJS.filters;
    var __globals = jinjaToJS.globals;
    var context = jinjaToJS.createContext(ctx);
    __result += "<div class=\"featured-promotions-wall mb20\"\n     is=\"featured-promotions-wall\">\n    ";__runtime.each(context.featured_promotions_wall.promotion_cards,function(promotion_landscape_card){var __$0 = context.promotion_landscape_card;context.promotion_landscape_card = promotion_landscape_card;__result += "\n        ";__result += "" + ((__tmp = (__$1(context))) == null ? "" : __tmp);__result += "\n    ";context.promotion_landscape_card = __$0;});__result += "\n</div>";
    return __result;
}